import React from "react";
import slider4 from "../images/Bg-img (2).png";
import './Bgimgs.css'

const Bgimgs = () => {
  return (
 <div className="feature-banner">
      <div className="feature-text">
        <h2>A place where nature meets nourishment. Explore pure, handcrafted products grown with love and harvested with care.</h2>

 <h6>“Let food be thy medicine and medicine be thy food.”<br/> - Hippocrates</h6>
   
      </div>
      {/* <div className="feature-image">
        <img
          src={slider4} // Change to your image path
          alt="Healthy Food"
        />
      </div> */}
    </div>
  );
};

export default Bgimgs;
